var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 12.0349C25 11.8511 24.9261 11.6755 24.7944 11.5457L17.4381 4.2857C17.1655 4.01544 16.7215 4.01544 16.448 4.2857L4.88159 15.7185C4.31271 16.2788 4 17.0248 4 17.8193C4 18.613 4.31316 19.358 4.88159 19.9183L8.72705 23.7123C8.79178 23.7767 8.86948 23.8276 8.95589 23.8632C9.04112 23.8979 9.13182 23.9163 9.22299 23.9163H23.3572C23.7437 23.9163 24.0573 23.6064 24.0573 23.2245C24.0573 22.8425 23.7437 22.5326 23.3572 22.5326H14.6662L24.7949 12.5241C24.9261 12.3943 25 12.2187 25 12.0349ZM9.5124 22.5326L5.87094 18.9391C5.56781 18.64 5.40051 18.2427 5.40051 17.8184C5.40051 17.395 5.56736 16.9968 5.87094 16.6977L8.47149 14.1271L13.6913 19.285C13.8281 19.4201 14.0072 19.4877 14.1863 19.4877C14.3655 19.4877 14.5446 19.4201 14.6814 19.285C14.9549 19.0147 14.9549 18.5769 14.6814 18.3067L9.46157 13.1488L16.9442 5.75317L23.3095 12.0349L12.6862 22.5326H9.5124Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/Clear.4484e18a93314877e5cf485bc7509ead.svg";
export { ForwardRef as ReactComponent };